import React from "react";
import { Comment } from "../api-requests/Comments";
import CommentItem from "./CommentItem";

interface CommentListProps {
  comments: Comment[];
  targetType: "debate" | "list" | "list_item";
  targetId: string;
  onCommentUpdated: (comment: Comment) => void;
  onCommentDeleted: (commentId: string) => void;
  onReplyAdded: (comment: Comment) => void;
  className?: string;
}

const CommentList: React.FC<CommentListProps> = ({
  comments,
  targetType,
  targetId,
  onCommentUpdated,
  onCommentDeleted,
  onReplyAdded,
  className = "",
}) => {
  if (comments.length === 0) {
    return null;
  }

  return (
    <div className={`space-y-4 ${className}`}>
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          targetType={targetType}
          targetId={targetId}
          onCommentUpdated={onCommentUpdated}
          onCommentDeleted={onCommentDeleted}
          onReplyAdded={onReplyAdded}
        />
      ))}
    </div>
  );
};

export default CommentList;
